import { ShareForm } from "../components/ShareForm";

export function ShareLandingRoute({ slug }: { slug: string }) {
  return (
    <main className="landing">
      <ShareForm slug={slug} />
    </main>
  );
}
